import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { toast } from "sonner";
import { Loader2, RotateCcw } from "lucide-react";
import { API } from "../../App";

export const ReopenDialog = ({ defect, onOpenChange, onDone }) => {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => setReason(""), [defect]);
  if (!defect) return null;

  const reopen = async () => {
    setBusy(true);
    try {
      const res = await fetch(`${API}/defects/${defect.id}/reopen`, {
        method: "POST",
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json" },
        body: JSON.stringify({ reason }),
      });
      const d = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(typeof d.detail === "string" ? d.detail : "Could not reopen");
      toast.success(`${defect.number} reopened — back to In Progress`);
      onDone();
      onOpenChange(false);
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  return (
    <Dialog open={!!defect} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="reopen-dialog">
        <DialogHeader className="text-left">
          <DialogTitle className="flex items-center gap-2"><RotateCcw className="w-5 h-5 text-amber-600" />Reopen {defect.number}</DialogTitle>
          <DialogDescription>
            It goes back to In Progress. {defect.client_visible ? "The client will see In Progress again and the approved completion photos are removed from their page." : ""}
          </DialogDescription>
        </DialogHeader>
        <Textarea value={reason} onChange={(e) => setReason(e.target.value.slice(0, 250))} placeholder="Reason, e.g. Client reports chip still visible"
          rows={3} data-testid="reopen-reason-input" />
        <p className="text-xs text-slate-500 text-right">{reason.length}/250</p>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="reopen-cancel">Cancel</Button>
          <Button onClick={reopen} disabled={busy || !reason.trim()} className="btn-construction" data-testid="reopen-confirm">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Reopen Defect"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
